[
  {
    "level": 1,
    "id": "direct_assassination",
    "name": "Direct Assassination",
    "day": 4,
    "targetRule": "player_location",
    "fallbackLocationId": "dawnmere",
    "battleId": "anti_player_assassination_battle",
    "encounterDialogueId": "anti_player_encounter_assassination",
    "absentFlags": [],
    "absentReport": "",
    "grantsKnowledge": ["met_anti_player"]
  },
  {
    "level": 2,
    "id": "route_ambush",
    "name": "Ambush on a Known Road",
    "day": 9,
    "targetRule": "known_route_node",
    "fallbackLocationId": "kings_road_crossroads",
    "battleId": "anti_player_ambush_battle",
    "encounterDialogueId": "anti_player_encounter_ambush",
    "absentFlags": ["anti_player_ambush_evaded"],
    "absentReport": "Travellers on the King's Road speak of armed men who lay in the ditch cutting all day and then simply walked away at dusk, having stopped nobody. They were waiting for someone who took a different road.",
    "grantsKnowledge": ["anti_player_learns_routes"]
  },
  {
    "level": 3,
    "id": "training_strike",
    "name": "Attack During Training",
    "day": 16,
    "targetRule": "training_site",
    "fallbackLocationId": "ironwatch_fortress",
    "battleId": "anti_player_training_strike_battle",
    "encounterDialogueId": "anti_player_encounter_training",
    "absentFlags": ["ironwatch_swordmaster_dead", "anti_player_killed_a_teacher"],
    "absentReport": "The Ironwatch swordmaster was found in the practice yard at first light with a single wound and no sign of a struggle. He taught nobody today, and he will teach nobody for the rest of this year.",
    "grantsKnowledge": ["anti_player_targets_teachers"]
  },
  {
    "level": 4,
    "id": "political_murder",
    "name": "Kill a Critical Contact",
    "day": 21,
    "targetRule": "fixed",
    "fallbackLocationId": "crownreach",
    "battleId": "anti_player_court_battle",
    "encounterDialogueId": "anti_player_encounter_court",
    "absentFlags": ["crownreach_chamberlain_dead", "anti_player_killed_a_teacher"],
    "absentReport": "The Court Chamberlain of Crownreach is dead in his own antechamber. Whoever did it knew exactly which door he used and exactly which hour he used it. The court is shut to petitioners and there is no longer anyone in it who arranges audiences.",
    "grantsKnowledge": ["anti_player_targets_court"]
  },
  {
    "level": 5,
    "id": "alliance_sabotage",
    "name": "Sabotage a Faction Alliance",
    "day": 28,
    "targetRule": "ally_home",
    "fallbackLocationId": "starbow_academy",
    "battleId": "anti_player_sabotage_battle",
    "encounterDialogueId": "anti_player_encounter_sabotage",
    "absentFlags": ["anti_player_sabotaged_an_alliance"],
    "absentReport": "Letters in your hand — your phrasing, your turns of speech, your signature — have been laid before an allied court, promising them to one enemy and selling them to another. They are forgeries. They are also extremely good forgeries, written by somebody who has heard you speak for a very long time.",
    "grantsKnowledge": ["anti_player_forges_letters"]
  },
  {
    "level": 6,
    "id": "army_infiltration",
    "name": "Infiltrate an Army",
    "day": 36,
    "targetRule": "largest_garrison",
    "fallbackLocationId": "ironwatch_fortress",
    "battleId": "anti_player_infiltration_battle",
    "encounterDialogueId": "anti_player_encounter_infiltration",
    "absentFlags": ["anti_player_turned_a_garrison"],
    "absentReport": "The garrison you left behind is gone. Not killed — gone. They were given orders in your name, by a man they had every reason to think spoke for you, and they marched out to obey them. Nobody has seen them since.",
    "grantsKnowledge": ["anti_player_infiltrates_armies"]
  },
  {
    "level": 7,
    "id": "direct_challenge",
    "name": "Challenge the Player Directly",
    "day": 44,
    "targetRule": "player_location",
    "fallbackLocationId": "kings_road_crossroads",
    "battleId": "anti_player_duel_battle",
    "encounterDialogueId": "anti_player_encounter_duel",
    "absentFlags": [],
    "absentReport": "",
    "grantsKnowledge": ["anti_player_stopped_hiding"]
  },
  {
    "level": 8,
    "id": "final_reckoning",
    "name": "The Reckoning at the Temple",
    "day": 30,
    "targetRule": "fixed",
    "fallbackLocationId": "ruined_temple_first_dawn",
    "battleId": null,
    "encounterDialogueId": "anti_player_encounter_final",
    "absentFlags": ["anti_player_waited_alone"],
    "absentReport": "Word reaches you that a grey-haired man sat on the temple steps from dawn until dark, spoke to nobody, and left. He was not hiding. He appears to have been waiting.",
    "grantsKnowledge": ["anti_player_awaits_at_temple"]
  }
]
